import { forwardRef, type ComponentPropsWithoutRef } from 'react';

import { cx } from './internal/cx.js';

export type CheckboxProps = Omit<ComponentPropsWithoutRef<'input'>, 'type'>;

/** Styled native checkbox input. Requires `@import '@nrx/ui/theme.css'`. */
export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(function Checkbox(
  { className, ...props },
  ref,
): React.JSX.Element {
  return <input ref={ref} type="checkbox" className={cx('nrx-checkbox', className)} {...props} />;
});
